/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import {service as ProjectStatusService} from "../../../Services/ProjectStatusService";
import autobind from "autobind-decorator";
import {FormControl} from "react-bootstrap";
import React from "react";

export class ProjectStatusFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props)

		this.setInitialState({
			projectStatuses: []
		});
	}

	componentDidMount() {
		ProjectStatusService.Get()
			.then((x) => {
				this.setState({projectStatuses: x.result});
			});
	}

	@autobind
	_render() {
		return <FormControl
			as="select"
			placeholder="Select A Status"
			value={this.props.Value != null ? this.props.Value : ""}
			onChange={(x) => this.props.OnUpdate(x.target.value)}
		>
			<option value="">Select A Status</option>
			{
				this.state.projectStatuses.map((x) => <option key={x.projectStatusId}
				                                              value={x.projectStatusId}>{x.name}</option>)
			}
		</FormControl>;
	}
}